import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Tracks how often the user reacts with each emoji so the quick-reaction bar can surface their
 * most-used ones (Facebook-Messenger style), with a sensible default set until they've reacted.
 * Local-only, persisted to localStorage.
 */
const DEFAULT_QUICK = ['👍', '❤️', '😂', '😮', '😢', '🔥']

interface EmojiUsageState {
  counts: Record<string, number>
  record: (emoji: string) => void
  /** The `count` most-used emojis, padded with defaults so the bar is always full. */
  topEmojis: (count?: number) => string[]
}

export const useEmojiUsageStore = create<EmojiUsageState>()(
  persist(
    (set, get) => ({
      counts: {},

      record: (emoji) =>
        set((state) => ({ counts: { ...state.counts, [emoji]: (state.counts[emoji] ?? 0) + 1 } })),

      topEmojis: (count = 6) => {
        const counts = get().counts
        const used = Object.keys(counts).sort((a, b) => counts[b] - counts[a])
        const result: string[] = []
        for (const e of [...used, ...DEFAULT_QUICK]) {
          if (!result.includes(e)) result.push(e)
          if (result.length >= count) break
        }
        return result
      },
    }),
    {
      name: 'adventurecore-emoji-usage',
      version: 1,
    }
  )
)
